// Params props.data

/**
 * Visitor type generates dynamic fields for creating second pages.
 * ie prospective student shows page with [hs_grad, college, etc...]
 * When selecting a value from page to we should overwrite original visitortype
 * @param steps
 */
// const decorateWithVisitorTypeTransform = (steps: any) =>
//   steps.map((step: any) => {
//     const fields = step.fields.map((field: any) =>
//       field.fieldId.indexOf('visitortype_') === -1
//         ? { ...field }
//         : { ...field, fieldId: 'visitortype' }
//     );
//     return { ...step, fields };
//   });

const decorateWithVisitorTypeTransform = (steps: any) => {
  // return steps.map((step: any) => {
  //   let fields = step.fields;
  //   let decoratedFields = fields.map((field: any) => {
  //     if (field.fieldId.indexOf('visitortype_') === -1) {
  //       return {...field};
  //     }
  //     return { ...field, fieldId: 'visitortype' };
  //   });
  //   return Object.assign(step, { fields: decoratedFields });
  // });
  return steps.map((step: any) => {
    const fields = step.fields.map((field: any) => {
      if (
        field.fieldId.indexOf('visitortype_') === -1 ||
        field.fieldId === 'visitortype_groups'
      ) {
        return { ...field };
      }
      return { ...field, fieldId: 'visitortype' };
    });
    return { ...step, fields };
    // return Object.assign(step, { fields: decoratedFields });
  });
};
export default decorateWithVisitorTypeTransform;
try {
    // @ts-ignore
    decorateWithVisitorTypeTransform.displayName = "decorateWithVisitorTypeTransform";
    // @ts-ignore
    decorateWithVisitorTypeTransform.__docgenInfo = { "description": "Visitor type generates dynamic fields for creating second pages.\nie prospective student shows page with [hs_grad, college, etc...]\nWhen selecting a value from page to we should overwrite original visitortype", "displayName": "decorateWithVisitorTypeTransform", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/decorateWithVisitorTypeTransform.ts#decorateWithVisitorTypeTransform"] = { docgenInfo: decorateWithVisitorTypeTransform.__docgenInfo, name: "decorateWithVisitorTypeTransform", path: "src/containers/stepContainer/dataTransform/decorateWithVisitorTypeTransform.ts#decorateWithVisitorTypeTransform" };
}
catch (__react_docgen_typescript_loader_error) { }